var _a;
import { __assign } from "tslib";
import { ReplyType } from '@wix/answers-api';
import { PublicEventType } from '../public';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger from '@wix/bi-logger-wix-answers';
export var pageTypeMap = (_a = {},
    _a[PublicEventType.HOME_PAGE_LOAD] = 'home',
    _a[PublicEventType.SEARCH_PAGE_LOAD] = 'search',
    _a[PublicEventType.CONTACT_PAGE_LOAD] = 'contact',
    _a[PublicEventType.USER_PAGE_LOAD] = 'user',
    _a);
export var getSearchResultIds = function (results) { return ({
    result_article_id_1: results.articles[0] ? results.articles[0].id : undefined,
    result_article_id_2: results.articles[1] ? results.articles[1].id : undefined,
    result_article_id_3: results.articles[2] ? results.articles[2].id : undefined,
}); };
export var getBaseTicketData = function (data) { return ({
    subject: sanitizePII(data.title),
    description: sanitizePII(data.description),
    form_source: data.contactFormLocation
}); };
export var maybeGetArticleId = function (maybeArticle) { return maybeArticle ? maybeArticle.id : undefined; };
export var getCategoryData = function (category, subcategory) { return ({
    category_id: category.id,
    category_name: category.name,
    sub_category_id: subcategory ? subcategory.id : undefined,
    sub_category_name: subcategory ? subcategory.name : undefined
}); };
export var getFullTicketData = function (data) { return (__assign(__assign({}, getBaseTicketData(data)), { is_attached: !!data.attachments.length, is_after_suggestion: data.isAfterSuggestion, article_id: maybeGetArticleId(data.sourceArticle) })); };
export var isItemCallNote = function (item) {
    return item.itemId !== undefined;
};
export var getTimelineItemData = function (item) {
    if (isItemCallNote(item)) {
        return { ticketId: item.itemId, replyId: item.id, replyType: 'call-note', content: item.content };
    }
    else {
        return {
            ticketId: item.ticketId,
            replyId: item.id,
            replyType: item.type === ReplyType.INTERNAL ? 'team-note' : 'reply',
            content: sanitizePII(item.content)
        };
    }
};
var wixTenantIds = [
    '12345678-1234-1234-1234-1234567890ab',
    '12345678-1234-1234-1234-1234567890ac' // dev center
];
export var isWixTenant = function (tenantId) {
    return wixTenantIds.indexOf(tenantId) !== -1;
};
export var createWixLogger = function (trackSession, webBiLoggerFactory) {
    return initSchemaLogger(webBiLoggerFactory || webBiLogger)({ trackSession: trackSession });
};
export var getScreenParmeters = function () { return ({
    screen_height: (window === null || window === void 0 ? void 0 : window.innerHeight) || 0,
    screen_width: (window === null || window === void 0 ? void 0 : window.innerWidth) || 0,
    screen_resolution_height: (screen === null || screen === void 0 ? void 0 : screen.height) || 0,
    screen_resolution_width: (screen === null || screen === void 0 ? void 0 : screen.width) || 0,
    pixel_ratio: String((window === null || window === void 0 ? void 0 : window.devicePixelRatio) || 0),
}); };
//# sourceMappingURL=wix-utils.js.map